/**
 * ORA - Video Rotation Hook
 * Manages video rotation state and logic for AI Agent
 */

import { useState } from "react";

const DEFAULT_VIDEO = "https://naskxuojfdqcunotdjzi.supabase.co/storage/v1/object/public/PrositionsNono/PersonalBrand_Persona.mp4";

const VIDEO_ROTATION = [
  "https://naskxuojfdqcunotdjzi.supabase.co/storage/v1/object/public/make-3504d096-videos/TransformationIntroHarvard.mp4",
  "https://naskxuojfdqcunotdjzi.supabase.co/storage/v1/object/public/make-3504d096-videos/DataIntroHarvard.mp4",
  "https://naskxuojfdqcunotdjzi.supabase.co/storage/v1/object/public/make-3504d096-videos/EmoLiteracy1.mp4",
  "https://naskxuojfdqcunotdjzi.supabase.co/storage/v1/object/public/make-3504d096-videos/Failures1.mp4",
  "https://naskxuojfdqcunotdjzi.supabase.co/storage/v1/object/public/make-3504d096-videos/NC4ME2.mp4",
  "https://naskxuojfdqcunotdjzi.supabase.co/storage/v1/object/public/make-3504d096-videos/MIT-Arnold.mp4",
  "https://naskxuojfdqcunotdjzi.supabase.co/storage/v1/object/public/make-3504d096-videos/KleeKaren2.mp4",
  "https://naskxuojfdqcunotdjzi.supabase.co/storage/v1/object/public/make-3504d096-videos/Big3Risk-RACI-Governance.mp4",
  "https://naskxuojfdqcunotdjzi.supabase.co/storage/v1/object/public/make-3504d096-videos/AgileMike.mp4",
  "https://naskxuojfdqcunotdjzi.supabase.co/storage/v1/object/public/make-3504d096-videos/HomePageMyPersonaShort.mp4",
  "https://naskxuojfdqcunotdjzi.supabase.co/storage/v1/object/public/make-3504d096-videos/Validation1.mp4",
  "https://naskxuojfdqcunotdjzi.supabase.co/storage/v1/object/public/make-3504d096-videos/USMCWentlang.mp4",
  "https://naskxuojfdqcunotdjzi.supabase.co/storage/v1/object/public/make-3504d096-videos/CWO-John2026.mp4",
  "https://naskxuojfdqcunotdjzi.supabase.co/storage/v1/object/public/make-3504d096-videos/Process-Citrus.mp4",
  "https://naskxuojfdqcunotdjzi.supabase.co/storage/v1/object/public/make-3504d096-videos/AI_Literacy_GovBriefpart2.mp4"
];

export function useVideoRotation() {
  const [currentVideo, setCurrentVideo] = useState(DEFAULT_VIDEO);
  const [queuedVideo, setQueuedVideo] = useState<string | null>(null);

  const handleVideoEnded = () => {
    // If there's a queued video, play it next
    if (queuedVideo) {
      setCurrentVideo(queuedVideo);
      setQueuedVideo(null); // Clear the queue
      return;
    }
    
    // Special handling: If SSgtW.mp4 just ended, play NC4ME2.mp4 next
    if (currentVideo === "https://naskxuojfdqcunotdjzi.supabase.co/storage/v1/object/public/make-3504d096-videos/SSgtW.mp4") {
      setCurrentVideo("https://naskxuojfdqcunotdjzi.supabase.co/storage/v1/object/public/make-3504d096-videos/NC4ME2.mp4");
      return;
    }
    
    // Get current rotation state
    const rotationData = localStorage.getItem('videoRotationState');
    let currentIndex = 0;
    
    if (rotationData) {
      const parsed = JSON.parse(rotationData);
      currentIndex = parsed.currentIndex || 0;
    }
    
    // Move to next video in rotation (never repeat the same video)
    currentIndex = (currentIndex + 1) % VIDEO_ROTATION.length;
    
    // Save updated state with showCount of 1 for the new video
    localStorage.setItem('videoRotationState', JSON.stringify({
      currentIndex,
      showCount: 1
    }));
    
    // Set the next video to display
    setCurrentVideo(VIDEO_ROTATION[currentIndex]);
  };

  const playSpecificVideo = (videoUrl: string) => {
    setCurrentVideo(videoUrl);
  };

  const queueVideoForNext = (videoUrl: string) => {
    setQueuedVideo(videoUrl);
  };

  const resetToDefaultVideo = () => {
    setCurrentVideo(DEFAULT_VIDEO);
  };

  return {
    currentVideo,
    setCurrentVideo,
    handleVideoEnded,
    playSpecificVideo,
    queueVideoForNext,
    resetToDefaultVideo,
    VIDEO_ROTATION,
    DEFAULT_VIDEO,
  };
}